import React from 'react';
import { useDataExports, useInAppMessage, useResponsive } from '../../../../hooks';
import { ExportBtnPDF } from "../../../molecules";
import useDataGrid from '../../data-grid/use-data-grid';
import { useI18N } from '../../../../hooks';

interface Props {
    className?: string;
    iconOnly?: boolean;
    disabled?: boolean;
    enableMobile?: boolean;
}
export default function ExportToPDF({ className, iconOnly, disabled, enableMobile }: Props) {
    const i18n = useI18N();
    const { localeKey } = i18n;
    const grid = useDataGrid();
    const message = useInAppMessage();
    const exports = useDataExports();
    const res = useResponsive();
    const isDisabled = (disabled) ? true : (grid.isLoading) ? true : false;
    const isIconOnly = (iconOnly) ? true : (!res.lgDown && enableMobile) ? true : false;
    const onExport = (count: number, data: any[]) => {
        const resolveExportMSG = () => message.createSuccess(`Exported ${count} ${(count === 1) ? 'row' : 'rows'}!`, { dismiss: 5000 });
        message.createLoading(`Exporting ${count} ${(count === 1) ? 'row' : 'rows'}...`);
        setTimeout(() => {
            exports.exportToPDF(data, grid.fields, resolveExportMSG);
        }, 2000);
    }
    const selectedOption = (grid.isOnRowSelect) ? [{
        label: `(${grid.selectedRows.length || 0}) ${i18n.translateThis('Selected', i18n.localize.selected)}`,
        onClick: () => onExport(grid.selectedRows.length || 0, grid.selectedRows)
    }] : []
    const customOptions = (typeof grid.exports.customOptions === 'object') ?
        grid.exports.customOptions.filter(
            (item) => {
                if (item.type === 'pdf') {
                    return item;
                }
            }) : [];

    const options = [
        {
            label: `(${grid.cachedTableData.length || 0}) Fetched`,
            onClick: () => onExport((typeof grid.totalDataCount === 'number') ? grid.cachedTableData.length : 0, grid.cachedTableData)
        },
        ...selectedOption,
        ...customOptions
    ]

    return (
        <>
            <ExportBtnPDF
                className={className}
                small
                data={grid.tableData}
                fields={grid.fields}
                options={options as any}
                iconOnly={isIconOnly}
                disabled={isDisabled}
            />
        </>
    )
}